import { render, staticRenderFns } from "./WexDisableLegacyInvestment.vue?vue&type=template&id=26e132b9&scoped=true"
import script from "./WexDisableLegacyInvestment.vue?vue&type=script&lang=ts"
export * from "./WexDisableLegacyInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e132b9",
  null
  
)

export default component.exports